/* eslint-disable @typescript-eslint/no-use-before-define */
import { DEFAULT_TENANT, WIDGET_COMPETITIONS_IDS } from '../config/config';
import tenantsConfig from '../config/tenantsConfig.json';
import translation from '../config/locales.json';
import { IIceHockeyCompetition } from '../interfaces/interfaces';

export function getParameterByName(optionName: string, url = window.location.href) {
  // eslint-disable-next-line no-param-reassign
  const name = optionName.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return '';
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

type IstringIndexTenants = {
  [key: string]: { name: string; language: string };
};
type IstringIndexLocale = {
  [key: string]: { [key: string]: string };
};

export const getTenantFromHost = (): string => {
  const host = document.referrer;

  const tenant = Object.keys(tenantsConfig).find((item) => host.includes(item));

  return tenant || DEFAULT_TENANT;
};

/* eslint-disable import/prefer-default-export */
export const getLanguageOption = (): string => {
  const queryStrings = window.location.search;
  if (queryStrings.indexOf('language') === -1) {
    const tenant = getTenantFromHost();
    if (tenant === '20min') {
      const host = document.referrer;
      if (host.includes('/fr')) {
        return 'fr';
      }
      return 'de';
    }
    return (<IstringIndexTenants>tenantsConfig)[tenant].language;
  }
  const indexOfLanguageOption = queryStrings.indexOf('language') + 'language'.length + 1;
  const language = queryStrings.substring(indexOfLanguageOption, indexOfLanguageOption + 2);
  return language;
};

export const getDefaultCompetitionIdQuery = (): string => {
  return WIDGET_COMPETITIONS_IDS.includes(getParameterByName('competitionId'))
    ? getParameterByName('competitionId')
    : '';
};

// Determines if a dark or light theme is set, and also listens to theme changes
export const determineBrowserTheme = (setTheme: (arg: string) => void): any => {
  if (!window.matchMedia) return undefined;
  const MediaQueryList: MediaQueryList = window.matchMedia('(prefers-color-scheme: dark)');
  if (MediaQueryList.matches) {
    setTheme('dark');
  } else {
    setTheme('light');
  }

  function dynamicTheme(e: any) {
    const newColorScheme = e.matches ? 'dark' : 'light';
    if (newColorScheme === 'dark') setTheme('dark');
    if (newColorScheme === 'light') setTheme('light');
  }
  MediaQueryList.addEventListener('change', dynamicTheme);

  return { MediaQueryList, event: 'change', theme: dynamicTheme };
};

export const trans = (string: string): string => {
  let lang = getLanguageOption();
  if (!(<IstringIndexLocale>translation)[lang]) {
    lang = 'de';
  }
  if (!(<IstringIndexLocale>translation)[lang][string]) return string;
  return (<IstringIndexLocale>translation)[lang][string];
};

export const getRealGameTimestamp = (gameDate: string): number => {
  if (!gameDate) return 0;
  // Get current utc timestamp
  const currentUTCTime = Date.now();
  // Pretend that current time in zurich is current utc time
  const utcTimePretendCet = `${convertLocaleFormatToZulu(
    new Date().toLocaleString('en-GB', { timeZone: 'Europe/Zurich' })
  )}Z`;
  // Pretend that current zurich time is current utc time and get timestamp as if it's the same hour in utc as it is currently in zurich
  // if it's 21h in zurich pretend it's also 21h in utc
  const pretendCetTimestamp = new Date(utcTimePretendCet).getTime();
  const zurichTimeOffset = pretendCetTimestamp - currentUTCTime;
  // Game date is already behaving like zurich time is actually utc time, get the timestamp as if the game is in utc time
  const gameDatePretendIsUtc = new Date(gameDate).getTime();
  // Now we have - if utc time is now 20h, gameDatePretendIsUtc: contains timestamp when utc clock gets to eg 21h (game time in zurich),
  // and through zurichTimeOffset we have timezone offset between cet and utc
  // By subtracting the offset from the utc timestamp (gameDatePretendIsUtc) that is set in the future, we get true utc timestamp of the game
  return gameDatePretendIsUtc - zurichTimeOffset;
};

function convertLocaleFormatToZulu(localeTime: string) {
  // cetTime will be in this format: 04/03/2021, 11:36:17
  const [date, hours] = localeTime.split(',');
  const [day, month, year] = date.split('/');
  const transformedDate = `${year}-${month}-${day}`;

  const time = `T${hours.trim()}.000`;
  const transformedDateTime = `${transformedDate}${time}`;
  // const gameTimeInUtc = new Date(transformedDateTime).toISOString();
  // gameTimeInUtc will be the same cetTime date converted to this format: '2021-03-02T21:10:00.000Z'
  return transformedDateTime;
}
